import React, { useState } from 'react'
import axios from 'axios'
import { Row, Col, Container, Card, CardBody, Progress } from 'reactstrap';
import Output from '../Output';

const ScannedToTextHindi = () => {

  const [file, setFile] = useState(null)
  const [fileData, setFileData] = useState(null)
  const [percentage, setPercentage] = useState(null)
  const [show, setShow] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault();
    let filetoconvert = file.file
    let formdata = new FormData()
    formdata.append('image', filetoconvert)
    formdata.append('name', 'Bhanu Kushwah')
    setShow(true)
    axios.post('https://api.cloudmersive.com/ocr/image/toText', formdata, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Accept': 'application/json',
        'recognitionMode': 'Normal',
        'language': 'HIN',
        'preprocessing': 'Auto',
        'Apikey': '0d1d50c8-3c1b-4453-bf87-27b556c29169'
      },
      onUploadProgress: (progressEvent) => {
        const {loaded, total} = progressEvent;
        let percent = Math.floor( (loaded * 100) / total)
        setPercentage(percent)
      }
    })
      .then(res => {
        const data = res.data
        setFileData(data)
        setShow(false)
      })
      .catch(error => {
        console.log(error)
      })
  }

  const handleFile = (e) => {
    var fileInput = document.getElementById('file');
    var filePath = fileInput.value;
    var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
    if(!allowedExtensions.exec(filePath)){
        alert('Please upload file having extensions .jpeg/.jpg/.png only.');
        fileInput.value = '';
        return false;
    }else{
        let file = e.target.files[0]
        setFile({ file: file })  
    }
  }


  return (
    <div>
      <div className="spacer ">
        <Container className="feature30">
          <Row>
            <Col lg="12" md="12" className="text-center">
              <Card className="card-shadow">
                <CardBody>
                  <div className="p-10">
                    <h3 className="title">Convert scanned image to text : Hindi</h3>
                    <p>Converts an uploaded image in common formats such as JPEG, PNG into text via Optical Character Recognition.</p>
                    <form  className="file-form" onSubmit={handleSubmit}>
                      <input type="file" id="file" name='file' className="btn  btn-md" onChange={(e) => handleFile(e)} required/>
                      
                      <button className="btn  bg-success-gradiant btn-md btn-arrow m-t-20" type="submit"><span>Extract <i className="ti-arrow-right"></i></span></button>
                    </form>
                  </div>
                  { show ? 
                     <div><div className="text-center m-t-20">{percentage}</div>
                    <Progress color="success" value={percentage} /></div> : <div></div>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {fileData!==null?<Output data={fileData}/> : <div></div>}
    </div>
  )
}
export default ScannedToTextHindi